import React from 'react';
import styled, { css } from 'styled-components';
import { PageLayoutComponent } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { PageConversationsLayout } from '../entities/page-conversations-layout';
import { withAuthenticationRequired } from '@auth0/auth0-react';
const cls = classNames('page-layout-conversations');

// -------- Child Component Props -------->

type ContainerProps = {

}

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
  
  `,
});

const ConversationsLayoutStyles = breakpoints({
  base: css`
    
  `,
  desktop: css`

  `,
});


// -------- Components -------->

const My = {
  Container: styled.div<ContainerProps>`${ContainerStyles}`,
  ConversationsLayout: styled(withAuthenticationRequired(PageConversationsLayout))`${ConversationsLayoutStyles}`,
};

export const PageLayoutConversations: PageLayoutComponent = 
(props) => {
  const { className, children, entity } = props;

  return (
    <My.Container className={cls.name(className)}>
      <My.ConversationsLayout entity={entity} />
    </My.Container>
  )
};